module.exports = __webpack_public_path__ + "img/position.e7b8556a.svg";